<template>
  <v-dialog
    v-model="visible"
    no-click-animation
    :width="'80%'"
  >
    <v-card>
      <v-card-title>
        <span class="title">繳款記錄 {{ item.displayId }} - {{ item.name }}</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <table-view
            :columnKeys="columnKeys"
            :items="items"
            :loading="loading"
            :total-items="totalItems"
            @changePage="changePage"
            @cellEvent="cellEvent"
            @handleLoadData="loadData"
          >
          </table-view>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn class="red" dark text @click="cancelEvent"
        >取消</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn class="primary" dark text @click="confirmEvent"
        >確認</v-btn
        >
      </v-card-actions>

    </v-card>
  </v-dialog>

</template>

<script>
import TableView from '@/components/TableView';
import { mapActions, mapGetters } from 'vuex';
import { getMarketPaymentInfo } from '@/store/actions';
export default {
  name: 'MarketPaymentListDialog',
  components: {
    TableView,
  },
  props:{
    visible: Boolean,
    orderId: String,
    item: Object,
  },
  data(){
    return {
      items:[],
      loading: false,
      pageIndex: 0,
      limit: 5,
      totalItems:0,
    }
  },
  watch: {
    visible(value) {
    },
    orderId(value){
      console.log(`find orderId = ${value}`);
      if (value){
        this.loadData();
      }
    }
  },
  mounted() {
    console.log('market payment');
    this.loadData();
  },
  computed:{
    ...mapGetters(['getUserInfo',]),
    getTotalItems() {
      return this.totalItems;
    },
    columnKeys() {
      let list = [
        {
          value: "no",
          text: "期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "paymentDate",
          text: "應繳日期",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          isSelect: false,
        },
        {
          value: "virtualAccount",
          text: "繳款帳號",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "price",
          text: "繳款金額",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "status",
          text: "狀態",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
          isSelect: true,
          options: [ { key: 0, text:'未繳款' },
            { key: 1, text:'已繳款' }],
        },
        {
          value: "diffDate",
          text: "逾期",
          colorText: true,
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          isSelect: false,
        },
        {
          value: "writeOffDate",
          text: "到帳時間",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          isSelect: false,
        },
        {
          value: "placeCategory",
          text: "繳費超商",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: false,
          isSelect: false,
        },
      ];
      return list;
    },
  },
  methods: {
    ...mapActions(['getMarketPaymentInfo']),
    changePage(page) {
      // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      // this.loadData();
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
    },
    async loadData() {
      this.loading = true;
      const data = {
        orderId: this.orderId
      }
      const results = await this.getMarketPaymentInfo(data);
      const result = results.data;
      if (result && result.statusCode === 0){
        this.items = result.data.paymentList;
        this.totalItems = this.items.length || 0 ;
      }
      this.loading = false;
    },
    cancelEvent(){
      this.$emit('cancelEvent');
    },
    confirmEvent(){
      this.$emit('confirmEvent');
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MarketPaymentListDialog.vue